import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractPageComponent, DocumentReference, SdkDictionaryService } from '@dsivd/prestations-ng';

import { BusinessForm } from '../../model/business-form';
import { Personne } from '../../model/personne';
import { InformationApplicantService } from '../../services/information-applicant/information-applicant.service';
import { RefCadorService } from '../../services/ref-cador/ref-cador.service';

@Component({
    templateUrl: './request-summary-page.component.html'
})
export class RequestSummaryPageComponent extends AbstractPageComponent<BusinessForm> implements OnInit {

    informationApplicantService: InformationApplicantService;

    constructor(
        protected activatedRoute: ActivatedRoute,
        private dictionaryService: SdkDictionaryService,
        informationApplicantService: InformationApplicantService
    ) {
        super(activatedRoute);
        this.informationApplicantService = informationApplicantService;
    }

    ngOnInit(): void {
        super.ngOnInit();
        super.setPageTitle(this.dictionaryService.getKeySync('request-summary.title'));
    }

    newForm(): BusinessForm {
        return new BusinessForm();
    }

    filterItems(item: Personne): Personne[] {
        const filterArray: Personne[] = [];
        filterArray.push(item);
        return filterArray.filter(p => p.role.code !== RefCadorService.CADOR_CODE_CONTACT_BENEFICIAIRE);
    }

    getAttachmentLinks(documents: DocumentReference[]): string {
        if (!documents || !documents.length) {
            return null;
        }

        return documents
            .map(doc => `<a href="api/document/download/${this.reference}/doc/${doc.reference}">${doc.filename}</a>`)
            .join('<br/>');
    }

    toStringOf(start: number[]): string {
        if (start && start.length > 0) {
            return `${start[2].valueOf() < 10 ?
                `0${start[2]}` :
                start[2]}.${start[1].valueOf() < 10 ? `0${start[1]}` : start[1]}.${start[0]}`;
        }

        return '';
    }
}
